import React, {
    useEffect,
    ElementType,
    PropsWithChildren,
    MouseEvent
} from "react";

import {ChangeLogOptions} from "../makes/Canny";
import {useCannyContext} from "../CannyContext";
import {SparklesStrongIcon } from 'src/monet/icons';
import { trackSegmentEvent } from 'src/utils/segment';

type Props = PropsWithChildren<{
    component?: ElementType;
    className?: string;
} & Partial<Omit<ChangeLogOptions, "appId">> & {
    [prop: string]: any;
}>;

const CannyChangelog: React.FC<Props> = (props) => {
    const {
        component: Component = "button",
        align = "left",
        position = "bottom",
        labelIDs,
        children,
        ...rest
    } = props;

    const {
        isLoaded,
        appId,
        canny
    } = useCannyContext();

    useEffect(() => {
        if(isLoaded && appId) {
            canny.initChangelog({
                appID: appId,
                align,
                position,
                labelIDs
            });

            return () => canny.closeChangelog();
        }
    }, [isLoaded, appId, align, position, labelIDs]);

    return (
        <Component
          {...rest}
          onClick={(event: MouseEvent<HTMLButtonElement, MouseEvent>) => {
            trackSegmentEvent('Sidebar Item Clicked', {
              item: "What's New",
            })
          }}
          className="flex rounded-lg items-center transition-colors hover:bg-bedrock-light-gray text-bedrock-black p-2 bg-bedrock-white shrink-0 space-x-sm"
          data-canny-changelog="">
            <SparklesStrongIcon className='w-4 h-4' />
            <span className='text-bedrock-p-strong'>What's New</span>
        </Component>
    );
};


export type {Props as CannyChangelogProps};
export {CannyChangelog};